import type { SVGProps } from 'react';

const SvgLogOut = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <path
      fill="currentcolor"
      d="M6 21.01h7c1.07 0 2.06-.57 2.6-1.5.28-.48.11-1.09-.37-1.37s-1.09-.11-1.37.37c-.18.31-.51.5-.87.5H6c-.55 0-1-.45-1-1v-12c0-.55.45-1 1-1h7c.36 0 .69.19.87.5.28.48.89.64 1.37.36s.64-.89.36-1.37C15.06 3.58 14.07 3 13 3H6c-1.65.01-3 1.36-3 3.01v12c0 1.65 1.35 3 3 3"
    />
    <path
      fill="currentcolor"
      d="M17.59 11.01H10c-.55 0-1 .45-1 1s.45 1 1 1h7.59L16.3 14.3a.996.996 0 1 0 1.41 1.41l3-3a.996.996 0 0 0 0-1.41l-3-3c-.2-.2-.45-.29-.71-.29s-.51.1-.71.29a.996.996 0 0 0 0 1.41z"
    />
  </svg>
);
export default SvgLogOut;
